import { useCallback } from "react";

import { PARNASSUS_HOST } from "@/challenges/utils/constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useClassroomsGet = () => {
  const createEventRecordRequest = useCallback((params) => {
    const challengesId = params.challengeId;
    const url = `${PARNASSUS_HOST}/challenges/${challengesId}/classrooms/`;
    const requestConfig = {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    };
    return new Request(url, requestConfig);
  }, []);
  return useRestMutation(createEventRecordRequest);
};

export default useClassroomsGet;
